export * from './entidade.model';
export * from './level2.model';
export * from './moradaalternativa.model';
export * from './tte-entidade.model';
export * from './client-rules.model';
